export default __webpack_public_path__ + "static/media/pic.57985b0e.png";